import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ customerReference2Error: string }>;

export const DispatchcustomerReference2Error: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/CustomerReference2Error",
        customerReference2Error: props.parameter.customerReference2Error,
    });
};

export const chain = [DispatchcustomerReference2Error];

const setCustomerReference2Error = createHandlerChainRunner(chain, "customerReference2Error");
export default setCustomerReference2Error;
